import { localAPI } from "../api/local";
import * as videoConstants from "../constants/videoConstants";
// const history = createBrowserHistory();
import history from "../config/history";
import { errorHandler } from "./errorHandler";

export const fetchVideos = (isPremium) => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_LIST_REQUEST,
  });
  try {
    const sortCondition = isPremium ? "sortas=premium" : "sortas=free";
    const data = await localAPI.get(`/api/videos?${sortCondition}`);
    dispatch({ type: videoConstants.VIDEO_LIST_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(videoConstants.VIDEO_LIST_FAIL, error, false, dispatch);
  }
};

export const fetchVideosAdmin = (handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_LIST_REQUEST,
  });
  try {
    const data = await localAPI.get("/api/videos/admin");
    dispatch({ type: videoConstants.VIDEO_LIST_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(videoConstants.VIDEO_LIST_FAIL, error, false, dispatch);
  }
};

export const fetchVideo = (videoId) => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_DETAILS_REQUEST,
  });
  try {
    const data = await localAPI.get(`/api/videos/link/${videoId}`);
    await dispatch({
      type: videoConstants.VIDEO_DETAILS_SUCCESS,
      payload: data,
    });
    return data.data.videoLink;
  } catch (error) {
    errorHandler(videoConstants.VIDEO_DETAILS_FAIL, error, false, dispatch);
  }
};

export const fetchAutoplayVideo = (playOrder) => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_AUTOPLAY_REQUEST,
  });
  try {
    const data = await localAPI.get(`/api/videos/next/${playOrder}`);
    await dispatch({
      type: videoConstants.VIDEO_AUTOPLAY_SUCCESS,
      payload: data,
    });

    return {
      videoId: data.data.videoId,
      videoLink: data.data.videoLink,
      nextVideoPlayOrder: data.data.playOrder,
    };
  } catch (error) {
    errorHandler(videoConstants.VIDEO_AUTOPLAY_FAIL, error, false, dispatch);
  }
};

export const createVideo = (video, handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_CREATE_REQUEST,
  });
  try {
    const data = await localAPI.post("/api/videos", video);
    dispatch({ type: videoConstants.VIDEO_CREATE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(videoConstants.VIDEO_CREATE_FAIL, error, false, dispatch);
  }
};

export const editVideo = (video, handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_UPDATE_REQUEST,
  });
  try {
    const data = await localAPI.patch(`/api/videos/${video._id}`, video);
    dispatch({ type: videoConstants.VIDEO_UPDATE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(videoConstants.VIDEO_UPDATE_FAIL, error, false, dispatch);
  }
};

export const deleteVideo = (videoId, handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_DELETE_REQUEST,
  });
  try {
    const data = await localAPI.delete(`/api/videos/${videoId}`);
    dispatch({ type: videoConstants.VIDEO_DELETE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(videoConstants.VIDEO_DELETE_FAIL, error, false, dispatch);
  }
};

export const videoWatched = (videoId) => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_WATCHED_REQUEST,
  });
  try {
    await localAPI.post(`/api/videos/watched/${videoId}`);
    dispatch({ type: videoConstants.VIDEO_WATCHED_SUCCESS });
  } catch (error) {
    errorHandler(videoConstants.VIDEO_WATCHED_FAIL, error, false, dispatch);
  }
};

export const getVideoCounter = () => async (dispatch) => {
  dispatch({
    type: videoConstants.VIDEO_COUNTER_REQUEST,
  });
  try {
    const data = await localAPI.get(`/api/videos/counter`);
    dispatch({ type: videoConstants.VIDEO_COUNTER_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(videoConstants.VIDEO_COUNTER_FAIL, error, false, dispatch);
  }
};
